<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>风控列表</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <!-- <div class="viewBox">
        <div class="left small">
          <div class="row">
            <div class="label black">{{ $t('sxfhz') }}(USDT)</div>
            <div class="text black">
              {{ rebateListTotal.totalFee }}
            </div>
          </div>
        </div>
        <div class="left small">
          <div class="row">
            <div class="label black">{{ $t('sxffyhz') }}(USDT)</div>
            <div class="text black">
              {{ rebateListTotal.rebateFee }}
            </div>
          </div>
        </div>
        
        <div class="left small">
          <div class="row">
            <div class="label black">手续费返佣发放(USDT)</div>
            <div class="text black">
              {{ rebateListTotal.rebateFeeSend }}
            </div>
          </div>
        </div>
      </div> -->

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                class="userUid_ipt"
                v-model="channelUserId"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="仓位ID"
                clearable
                class="userUid_ipt"
                v-model="positionId"
              >
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
              <div class="ipt">
                <el-select
                  v-model="rebateType"
                  clearable
                  :placeholder="$t('fylx')"
                  size="small"
                >
                  <el-option
                    v-for="item in typeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div> -->
          <!-- <div class="item">
              <div class="ipt">
                <el-input
                  :placeholder="$t('remark')"
                  clearable
                  v-model="remark"
                  class="userUid_ipt"
                >
                </el-input>
              </div>
            </div> -->
          <!-- <div class="item">
              <div class="ipt">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  align="center"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :clearable="true"
                  range-separator="-"
                  :start-placeholder="$t('ksrq')"
                  :end-placeholder="$t('jsrq')"
                  @change="changeTime($event)"
                  :picker-options="pickerOptions"
                  :prefix-icon="$t('zw')"
                >
                </el-date-picker>
                <img :src="timeImg" alt="" class="timeIcon" />
              </div>
            </div> -->
          <!-- <div class="item">
              <el-button
                @click="searchYesterday"
                type="primary"
                class="dateBtn"
                >{{ $t('yesterday') }}</el-button
              >
            </div> -->
          <!-- <div class="item">
              <el-button @click="searchToday" type="primary" class="dateBtn">{{
                $t('today')
              }}</el-button>
            </div> -->
          <div class="item">
            <el-button class="searchBtn" type="primary" @click="handleSearch"
              >查询</el-button
            >
            <!-- <el-button  @click="exportData" size="mini">导出Excel</el-button> -->
          </div>
        </div>
      </div>

      <TableList @refresh="refreshList"></TableList>
    </el-card>
  </div>
</template>

<script>
import './store'
import TableList from './components/list'
import { mapState, mapActions, mapMutations } from 'vuex'
import { PAGINATION } from './constants'
import moment from 'moment'
import api from './api'
export default {
  components: {
    TableList,
  },
  data() {
    return {
      userId: '',
      positionId: '',
      channelUserId: '',
      remark: '',
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //   '-' +
      //   (new Date().getMonth() + 1) +
      //   '-' +
      //   new Date().getDate(),
      // ],
      value1: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      totalInfo: {
        rechargeAmount: 0,
        txAmount: 0,
        recharge: 0,
        profit: 0,
        realizedProfit: 0,
        totalFee: 0,
      },
      typeArr: [
        { value: 1, label: '合约返佣' },
        { value: 2, label: '现货返佣' },
      ],
      rebateType: '',
    }
  },
  computed: {
    ...mapState('rebateRisk', ['pagination', 'rebateListTotal']),
  },
  methods: {
    ...mapActions('rebateRisk', ['list', 'exportExcel', 'fetchRebateListTotal']),
    refreshList(data = {}) {
      this.getList(data)
      // this.getRebateListTotal()
    },
    exportData() {
      const data = {
        positionId: this.positionId,
        channelUserId: this.channelUserId,
        userId: this.userId,
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        page: this.pagination.page,
        size: this.pagination.size,
      }
      api.getExcelData(data).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址

        link.download = '风控仓位'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },
    changeTime(e) {
      this.getList()
      // this.getRebateListTotal()
    },
    handleSearch() {
      this.getList()
      // this.getRebateListTotal()
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    getList(pagination) {
      this.list({
        // startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        // endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,

        ...PAGINATION,
        ...pagination,
      })
    },
    getRebateListTotal() {
      this.fetchRebateListTotal({
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        channelUserId: this.channelUserId,
        positionId: this.positionId,
        rebateType: this.rebateType,
        userId: this.userId,
      })
    },
  },
  mounted() {
    this.getList()
    // this.getRebateListTotal()
  },
}
</script>

<style lang="less" scoped>
@import url(~@/styles/button.less);
</style>
